// eslint-disable-next-line @typescript-eslint/no-empty-function
import {Env} from '@ok/common/utils/env';

// eslint-disable-next-line @typescript-eslint/no-empty-function
function emptyFn() {}
export const Logger = Env.isServerRendering
    ? {success: emptyFn, duration: emptyFn, error: emptyFn, errorEx: emptyFn, info: emptyFn, clob: emptyFn, log: emptyFn, trace: emptyFn}
    : window.OK.react.logging.logger;
